import { gql, useQuery } from '@apollo/client';
import _ from 'lodash';

export const GET_ROUTERS = gql`
  query GetRouters($customerId: Float!) {
    getRouters(input: { customer_id: $customerId }) {
      result {
        id
        name
        status
      }
      success
      errors
    }
  }
`;

type GetRoutersResult = {
  getRouters: {
    result?: Array<{
      id: string;
      name?: string;
      status?: string;
    }>;
    success: boolean;
    errors?: string[];
  };
};

interface UseGetRoutersOptions {
  skip?: boolean;
}

export const useGetRouters = (
  customerId: number,
  options: UseGetRoutersOptions = {}
) => {
  const { data, loading, error } = useQuery<GetRoutersResult>(
    GET_ROUTERS,
    {
      variables: { customerId },
      skip: options.skip || customerId == null 
    }
  );

  return {
    loading,
    error,
    routers: data?.getRouters?.result ?? [],
    success: data?.getRouters?.success ?? false,
    errors: data?.getRouters?.errors ?? []
  };
};